import React from 'react'

const Store = (props) => {

  document.title = 'Store - ' + window.seoTagLine;
  
  return (
    <div className="container ptb-70">
      <h4 className="">Store</h4>
      <div className="text-bold fs-20 text-center mt-100">Coming Soon...</div>
    </div>
  )
}

export default Store
